export default __webpack_public_path__ + "static/media/2FoldEmbryo.82690d70.svg";